/**
 * Constants for scroll behavior and timing
 */

// Section height measurement thresholds
export const SCROLL_THRESHOLDS = {
  // Minimum height change to trigger update (in pixels)
  HEIGHT_CHANGE_THRESHOLD: 5,

  // Number of stable measurements before disconnecting ResizeObserver
  RESIZE_STABILITY_COUNT: 3,
} as const;

// Section loading configuration
export const SECTION_LOADING = {
  // Number of sections to preload on initial render
  PRELOAD_COUNT: 3,
} as const;
